/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { createAsyncAction, ActionType } from "typesafe-actions"
import { AjaxError } from "rxjs/ajax";

interface TrainingRecord {
  type: string;
  expires: string;
  updated: string;
}

export interface UserDescription {
  id: string;
  name: string;
  customIds: string[];
  email: string;
  organization: string;
  address:	string;
  city:	string;
  state:	string;
  zip:	string;
  phone:	string;
  trainingRecords: TrainingRecord[];
  coopsEval: string[];
  farmsEval: string[];
  roles: string[];
  certifications: { [key: string]: TrainingRecord };
}

export interface UserListDescription {
  id: string;
  name: string;
  customIds: string[];
  email: string;
  organization: string;
  address:	string;
  city:	string;
  state:	string;
  zip:	string;
  phone:	string;
  certifications: { [key: string]: TrainingRecord };
  trainingRecords: TrainingRecord[];
  coopsEval: string[];
  farmsEval: string[];
}

export interface UserSimple {
  id: string;
  name: string;
  email: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  subscribed: boolean;
  company: string;
}

export interface Manager {
  id: string | null;
  name: string | null;
  email: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  phone: string | null;
  subscribed: boolean;
  company: string | null;
  new: boolean;
}

export const fetchUserDetails = createAsyncAction(
  "FETCH_USER_REQUEST",
  "FETCH_USER_SUCCESS",
  "FETCH_USER_FAIL"
)<undefined, UserDescription, AjaxError>();

export const fetchUsers = createAsyncAction(
  "FETCH_USERS_REQUEST",
  "FETCH_USERS_SUCCESS",
  "FETCH_USERS_FAIL"
)<undefined, any, AjaxError>();

export const saveUsers = createAsyncAction(
  "SAVE_USERS_REQUEST",
  "SAVE_USERS_SUCCESS",
  "SAVE_USERS_FAIL"
)<UserDescription[], undefined, AjaxError>();

export const loadUsers = createAsyncAction(
  "LOAD_USERS_REQUEST",
  "LOAD_USERS_SUCCESS",
  "LOAD_USERS_FAIL"
)<string, UserDescription[], AjaxError>();

export type UserActions = 
  | ActionType<typeof fetchUserDetails>
  | ActionType<typeof fetchUsers>
  | ActionType<typeof saveUsers>
  | ActionType<typeof loadUsers>;
